import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './moduloActions';
import Table from '../common/table/table';
import TBody from '../common/table/tBody';
import Tr from '../common/table/tr';
import Td from '../common/table/td';
import modulo from './modulo';

class ModuloForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='palavras_chave'
								component={LabelAndInput}
								label='Palavras Chave (separe com vírgula)' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
						
						{/*	
							<Table responsive>
								<TBody>
									{this.props.listaModulo.map(modulo => (
										<>
											<Tr key={modulo.id}>
												<Td>
													<div class='icheck-success d-inline'
														style={{ marginLeft: 8 }}>
														<input 
															id={`checkboxModulo${modulo.id}`}
															type='checkbox'															
															disabled={readOnly}
															checked={this.props.formularioValues.json_acesso.filter(acesso => acesso.id_modulo == modulo.id).length}
															onChange={data => {
																let jsonAcesso = this.props.formularioValues.json_acesso.map(item => ({ ...item }));

																if (jsonAcesso.filter(acesso => acesso.id_modulo == modulo.id).length) {
																	jsonAcesso = jsonAcesso.filter(acesso => acesso.id_modulo != modulo.id);
																} else {
																	jsonAcesso.push({
																		id_modulo: modulo.id,
																		telas: (modulo.telas || []).filter(tela => tela).map(tela => ({
																			id_tela: tela.id,
																			permissoes: (tela.permissoes || []).filter(permissao => permissao).map(permissao => ({ id_permissao: permissao.id }))
																		}))
																	});
																}

																this.props.initForm({
																	...this.props.formularioValues,
																	json_acesso: jsonAcesso
																});
															}} />
															<label for={`checkboxModulo${modulo.id}`}>{modulo.nome}</label>
													</div>
												</Td>
											</Tr>
											{(modulo.telas || []).filter(tela => tela).length > 0 &&
											<div style={{ marginLeft: 38 }}>
												<Table key={`${modulo.id}-modulo`} responsive marginBottom={0}>
													<TBody>
														{(modulo.telas || []).filter(tela => tela).map(tela => (
															<>
																<Tr key={tela.id} >
																	<Td>
																		<div class='icheck-success d-inline'
																			style={{ marginLeft: 8 }}>
																			<input 
																				id={`checkboxTela${tela.id}`}
																				type='checkbox'															
																				disabled={this.props.formularioValues.json_acesso.filter(acesso => acesso.id_modulo == modulo.id).length ? readOnly : 'realOnly'}
																				checked={this.props.formularioValues.json_acesso.filter(acesso => 
																					acesso.id_modulo == modulo.id
																					&& acesso.telas.filter(acessoTela => acessoTela.id_tela == tela.id).length
																				).length}
																				onChange={data => {
																					let jsonAcesso = this.props.formularioValues.json_acesso.map(item => {

																						if (item.telas.filter(acessoTela => acessoTela.id_tela == tela.id).length) {
																							return {
																								...item,
																								telas: item.telas.filter(acessoTela => acessoTela.id_tela != tela.id)
																							};
																						} else {
																							let telas = item.telas.map(acessoTela => ({ ...acessoTela }));
																							telas.push({
																								id_tela: tela.id,
																								permissoes: (tela.permissoes || []).filter(permissao => permissao).map(permissao => ({ id_permissao: permissao.id }))
																							});

																							return {
																								...item,
																								telas: telas
																							};
																						}
																					});

																					this.props.initForm({
																						...this.props.formularioValues,
																						json_acesso: jsonAcesso
																					});
																				}} />
																				<label for={`checkboxTela${tela.id}`} style={{ fontWeight: 'normal' }}>{tela.nome}</label>
																		</div>
																	</Td>
																</Tr>
																{(tela.permissoes || []).filter(permissao => permissao).length > 0 &&
																<div style={{ marginLeft: 30 }}>
																	<Table key={`${tela.id}-permissao`} responsive marginBottom={0}>
																		<TBody>
																			{(tela.permissoes || []).filter(permissao => permissao).map(permissao => (
																				<Tr key={permissao.id} >
																					<Td>
																						<div class='icheck-success d-inline'
																							style={{ marginLeft: 8 }}>
																							<input 
																								id={`checkboxPermissao${permissao.id}`}
																								type='checkbox'															
																								disabled={this.props.formularioValues.json_acesso.filter(acesso => 
																									acesso.id_modulo == modulo.id
																									&& acesso.telas.filter(acessoTela => acessoTela.id_tela == tela.id).length
																								).length ? readOnly : 'readOnly'}
																								checked={this.props.formularioValues.json_acesso.filter(acesso => 
																									acesso.id_modulo == modulo.id
																									&& acesso.telas.filter(acessoTela => 
																										acessoTela.id_tela == tela.id
																										&& acessoTela.permissoes.filter(acessoPermissao => acessoPermissao.id_permissao == permissao.id).length
																									).length
																								).length}
																								onChange={data => {
																									let jsonAcesso = this.props.formularioValues.json_acesso.map(item => ({
																										...item,
																										telas: item.telas.map(acessoTela => {
																											if (acessoTela.permissoes.filter(acessoPermissao => acessoPermissao.id_permissao == permissao.id).length) {
																												return {
																													...acessoTela,
																													permissoes: acessoTela.permissoes.filter(acessoPermissao => acessoPermissao.id_permissao != permissao.id)
																												};
																											} else {
																												let permissoes = acessoTela.permissoes.map(acessoPermissao => ({ ...acessoPermissao }));
																												permissoes.push({
																													id_permissao: permissao.id
																												});
																												return {
																													...acessoTela,
																													permissoes: permissoes
																												};
																											}
																										})
																									}));

																									this.props.initForm({
																										...this.props.formularioValues,
																										json_acesso: jsonAcesso
																									});
																								}} />
																								<label for={`checkboxPermissao${permissao.id}`} style={{ fontWeight: 'normal', fontStyle: 'italic' }}>{permissao.nome}</label>
																						</div>
																					</Td>
																				</Tr>
																			))}
																		</TBody>
																	</Table>
																</div>}
															</>
														))}
													</TBody>
												</Table>
											</div>}
										</>
									))}
								</TBody>
							</Table>
						*/}
						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

ModuloForm = reduxForm({form: 'moduloForm', destroyOnUnmount: false})(ModuloForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('moduloForm')(state),
	registro: state.modulo.registro,
	listaModulo: state.modulo.listaModulo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ModuloForm);
